import { useState } from "react";

const useDisabledFeatureSettingNames = (): [
    string[],
    (valuesToAdd: string[]) => void,
    (valueToRemove: string) => void,
] => {
    const [disabledSettingNames, setDisabledSettingNames] = useState<string[]>(
        []
    );

    const addNames = (valuesToAdd: string[]) => {
        setDisabledSettingNames([
            ...new Set([...disabledSettingNames, ...valuesToAdd]),
        ]);
    };

    const removeName = (valueToRemove: string) => {
        setDisabledSettingNames(
            disabledSettingNames.filter((name) => name !== valueToRemove)
        );
    };

    return [disabledSettingNames, addNames, removeName];
};

export default useDisabledFeatureSettingNames;
